import { useState } from "react";
import { prettifyApiError } from "@/shared/api";
import { setSupplierPaid } from "../api";
import type { Order } from "../types";
import { ACTION_ICON_CLS, ActionButton } from "./ActionButton";
import { IconCheckSquare } from "./icons";

/** Tasto «Pagato» della colonna Azioni (Davide 2026-09-10/11): segna che la
 *  fattura del fornitore e' pagata, cioe' il campo ``paid`` che spegne il badge
 *  «DA PAGARE». Esiste solo dove quel badge ha senso — ordini con un fornitore
 *  da pagare, o gia' pagati per poterlo disfare — cosi' non ruba uno slot della
 *  griglia agli ordini a cui non serve.
 *
 *  Un click solo: il dato e' locale e reversibile, e il tasto dice subito com'e'
 *  andata (verde = pagato). Niente scrittura ottimista sui soldi: si aspetta la
 *  risposta e si ricarica la lista. */
export function PagatoButton({ order, onDone }: { order: Order; onDone?: () => void }) {
  const [busy, setBusy] = useState(false);
  const [errore, setErrore] = useState<string | null>(null);
  const pagato = order.paid === true;
  return (
    <span className="relative inline-flex">
      <ActionButton
        tone={pagato ? "emerald" : "pink"}
        icon={<IconCheckSquare className={ACTION_ICON_CLS} />}
        label="Pagato"
        busy={busy}
        ariaLabel={
          pagato ? `Fornitore pagato, ordine ${order.id}` : `Segna pagato ordine ${order.id}`
        }
        title={
          errore ??
          (pagato
            ? "Fornitore pagato. Clic per togliere il segno."
            : "Segna che la fattura del fornitore e' stata pagata")
        }
        onClick={(e) => {
          e.stopPropagation();
          setBusy(true);
          setErrore(null);
          void setSupplierPaid(order.id, !pagato)
            .then(() => onDone?.())
            .catch((err: unknown) => setErrore(prettifyApiError(err)))
            .finally(() => setBusy(false));
        }}
      />
      {errore && (
        <span
          role="alert"
          className="absolute -bottom-1 right-0 translate-y-full whitespace-nowrap text-[10px] text-red"
        >
          {errore}
        </span>
      )}
    </span>
  );
}
